export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'name', label: 'Name' },
  { name: 'salesforce_id', label: 'Salesforce ID' }
]



// WEBPACK FOOTER //
// ./src/fields/companies.js